import React, { useState, useRef, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import ReactDOM from 'react-dom';
import './StandardTable.css';

const StandardTable = ({
    columns,
    data,
    search,
    onSearchChange,
    searchPlaceholder = "Zoeken...",
    loading = false,
    isAdmin = false,
    activeMenuRow: externalActiveMenuRow,
    setActiveMenuRow: externalSetActiveMenuRow,
    paginationServer = false,
    paginationTotalRows,
    onChangePage,
    onChangeRowsPerPage,
    ...props
}) => {
    const [internalActiveMenuRow, setInternalActiveMenuRow] = useState(null);
    const activeMenuRow = externalActiveMenuRow !== undefined ? externalActiveMenuRow : internalActiveMenuRow;
    const setActiveMenuRow = externalSetActiveMenuRow || setInternalActiveMenuRow;

    const ActionsCell = ({ row, activeMenuRow, setActiveMenuRow }) => {
        const buttonRef = useRef(null);
        const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

        useEffect(() => {
            if (activeMenuRow === row.id && buttonRef.current) {
                const rect = buttonRef.current.getBoundingClientRect();
                setDropdownPosition({
                    top: rect.bottom + window.scrollY,
                    left: rect.right + window.scrollX - 120 // minWidth 120px
                });
            }
        }, [activeMenuRow, row.id]);

        return (
            <div style={{ position: 'relative' }}>
                <button
                    ref={buttonRef}
                    className="btn-action-trigger"
                    onClick={() => setActiveMenuRow(row.id === activeMenuRow ? null : row.id)}
                >
                    <i className="fas fa-ellipsis-v action-icon"></i>
                </button>
                {activeMenuRow === row.id && ReactDOM.createPortal(
                    <div className="dropdown-menu show table-actions-dropdown" style={{ position: 'absolute', top: dropdownPosition.top, left: dropdownPosition.left, minWidth: '120px' }}>
                        {row.actions && row.actions.map(action => (
                            <button
                                key={action.label}
                                className="dropdown-item"
                                onClick={() => {
                                    setActiveMenuRow(null);
                                    action.onClick(row);
                                }}
                            >
                                {action.label}
                            </button>
                        ))}
                    </div>,
                    document.body
                )}
            </div>
        );
    };

    const modifiedColumns = columns.map(col => {
        if (col.name === 'Actions') {
            return {
                ...col,
                cell: row => <ActionsCell row={row} activeMenuRow={activeMenuRow} setActiveMenuRow={setActiveMenuRow} />,
            };
        }
        return col;
    });

    // We still need to pass customStyles object to RDT, but we can simplify it and reference CSS vars/tokens if we had them.
    // For now, we will keep the necessary JS styles to ensure RDT behaves, but we've moved what we can (like search input) to CSS.
    // Note: classNames in RDT are limited, so we use customStyles for granular control where CSS classes on the container don't reach.
    const customStyles = {
        headRow: {
            style: {
                fontFamily: 'Atyp Semi, Montserrat',
                backgroundColor: '#F0EBE9',
                borderBottom: 'none',
            },
        },
        headCells: {
            style: {
                fontFamily: 'Atyp Semi, Montserrat',
                backgroundColor: '#F0EBE9',
                fontSize: '18px',
                color: '#9E9E9E',
            },
        },
        rows: {
            style: {
                borderBottom: 'none',
                borderRadius: '10px',
                minHeight: '50px',
                padding: '15px 10px',
                backgroundColor: 'transparent',
                marginBottom: '5px',
            },
        },
        cells: {
            style: {
                border: 'none',
                backgroundColor: 'transparent',
            },
        },
        subHeader: {
            style: {
                backgroundColor: 'transparent',
                padding: 0,
            },
        },
        pagination: {
            style: {
                backgroundColor: '#F0EBE9',
                borderTop: 'none',
                borderRadius: '0 0 10px 10px',
            },
        },
    };

    return (
        <div className="standard-table-container">
            <DataTable
                columns={modifiedColumns}
                data={data}
                pagination
                highlightOnHover
                persistTableHead
                responsive
                paginationServer={paginationServer}
                paginationTotalRows={paginationTotalRows}
                onChangePage={onChangePage}
                onChangeRowsPerPage={onChangeRowsPerPage}
                customStyles={customStyles}
                subHeader
                subHeaderComponent={
                    <div className="table-search-container">
                        <input
                            type="text"
                            className="form-control table-search-input"
                            placeholder={searchPlaceholder}
                            value={search}
                            onChange={onSearchChange}
                        />
                    </div>
                }
                progressPending={loading}
                {...props}
            />
        </div>
    );
};

export default StandardTable;